import React from "react";
import { FiBriefcase } from "react-icons/fi";
import ServicePlanPage from "../components/options/ServicePlanPage";
import { juridiqueGuide } from "../components/guide/guideContent";
import pricing from "../assets/data/pricing.json";

function PlatformJuridique() {
  return (
    <ServicePlanPage
      serviceKey="platformJuridique"
      icon={FiBriefcase}
      title={
        <>
          Le <span>suivi juridique</span> de votre entreprise
        </>
      }
      lead="Contentieux, contrats d'affaires et secrétariat juridique : nos juristes sécurisent votre activité au quotidien."
      cardTitle="Suivi juridique"
      summary="Un accompagnement juridique adapté à vos besoins pour protéger vos intérêts."
      prices={pricing.platformJuridique}
      guide={juridiqueGuide}
    />
  );
}

export default PlatformJuridique;
